import { render, staticRenderFns } from "./DataManaIndex.vue?vue&type=template&id=144b2e7e&scoped=true&"
import script from "./DataManaIndex.vue?vue&type=script&lang=js&"
export * from "./DataManaIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144b2e7e",
  null
  
)

export default component.exports